module.exports = __webpack_public_path__ + "img/down-active.9063b6be.svg";